const baseURL = 'https://laolgueta.com/';

export default baseURL;
